'use strict';

wbApp.controller('CoursesCtrl', ['$scope', '$window', 'tenantSettingSvc', 'urlUtils',
function ($scope, $window, tenantSettingSvc, urlUtils) {
    var data = semestersWithCourses;

    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.semesters = data;
    $scope.availableAgeRanges = [];
    $scope.availableCourseTypes = [];

    $scope.courseTypeID = urlUtils.getQueryParams()['courseTypeID'];

    $scope.setSelectedCourse = function (course) {
        //if (course.freeCapacity !== 0 ||
           // $scope.tenantSettings.courseInterestsSupport ||
           // $scope.tenantSettings.coursePreviewOnlyRegistration) {
            $scope.selectedCourse = course;
            $window.location.assign("/Courses/Register/" + course.id + "?returnUrl=Courses");
       // }
    }

    $scope.tabs = [];

    function PrepareTabs() {
        for (var i = 0; i < $scope.semesters.length; i++) {
            var semester = $scope.semesters[i];
            $scope.tabs.push({ 
                title: semester.name,
                semesterID: semester.semesterID,
                template: "courses/semester-detail-tab.html",
            });
            $scope.availableAgeRanges.push(_.keyBy(_.uniq(_.map(semester.courses, 'courseAgeRangeID'))));
            $scope.availableCourseTypes.push(_.keyBy(_.uniq(_.map(semester.courses, 'courseTypeID'))));
        }
    }

    PrepareTabs();

    switchToCorrectTab();


    function switchToCorrectTab() {
        var semesterIDStr = urlUtils.getQueryParams()['semesterID'];
        if (!!semesterIDStr) {

            var semesterID = Number(semesterIDStr);
            // find correct tab
            var tabIndexToActivate = _.findIndex($scope.tabs, { semesterID: semesterID });
            if (tabIndexToActivate !== -1 && $scope.tabs.activeTab !== tabIndexToActivate) {
                $scope.tabs.activeTab = tabIndexToActivate;
                return;
            }

        } 

        urlUtils.setUrlParam("semesterID", null);
        $scope.tabs.activeTab = 0;        
    }

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        var semesterID = $scope.tabs[newValue].semesterID;

        urlUtils.setUrlParam("semesterID", semesterID);       
    });
    
}]);